export default "__VITE_ASSET__BIk8$5z1__"